import { EventEmitter } from '@timing71/common';

export const makeWrappedWebsocket = (connectionService) => {

  class WrappedWebsocket extends EventEmitter {

    constructor(url, protocols = []) {
      super();
      this._socket = connectionService.createWebsocket(url, {
        autoReconnect: false,
        protocols
      });
      this._socket.onopen = this._handleOpen.bind(this);
      this._socket.onclose = this._handleClose.bind(this);
      this._socket.onerror = this._handleError.bind(this);
      this._socket.onmessage = this._handleMessage.bind(this);
      this.close = this.close.bind(this);
      this.send = this.send.bind(this);

      this.readyState = 0;
    }

    _handleOpen(e) {
      this.readyState = 1;
      this.emit('open', e);
      if (this.onopen) {
        this.onopen(e);
      }
    }

    _handleClose(e) {
      this.readyState = 3;
      this.emit('close', e);
      if (this.onclose) {
        this.onclose(e);
      }
    }

    _handleError(e) {
      this.emit(e);
      if (this.onerror) {
        this.onerror(e);
      }
    }

    _handleMessage(e) {
      this.emit('message', e);
      if (this.onmessage) {
        this.onmessage(e);
      }
    }

    send(data) {
      return this._socket.send(data);
    }

    close() {
      this._socket?.close();
    }
  }

  WrappedWebsocket.CONNECTING = 0
  WrappedWebsocket.OPEN = 1
  WrappedWebsocket.CLOSING = 2
  WrappedWebsocket.CLOSED = 3

  return WrappedWebsocket;
}
